import React from 'react';
import OurLeadsContent from '../function-components/OurLeadsContent';

function OurLeads() {
    return (
        <>
            <OurLeadsContent />
        </>
    )
}

export default OurLeads